import React from "react";
import { IoBookmarkOutline } from "react-icons/io5";
import { IoBookmark } from "react-icons/io5";
import NavButton from "./NavButton";

interface DictionaryButtonProps {
  isActive: boolean;
  onClick: () => void;
  /** Review-count badge (cards due). Hidden when 0. iOS ref: _layout.tsx:85. */
  reviewCount?: number;
}

const DictionaryButton: React.FC<DictionaryButtonProps> = ({
  isActive,
  onClick,
  reviewCount,
}) => {
  return (
    <NavButton
      isActive={isActive}
      onClick={onClick}
      // iOS ref: bookmark / bookmark.fill (single bookmark, _layout.tsx:80).
      icon={<IoBookmarkOutline className="h-full w-auto" />}
      // fill icon inherits the active blue tint from NavButton (no hardcoded grey).
      fillIcon={<IoBookmark className="h-full w-auto" />}
      text="Dictionary"
      badge={reviewCount}
    />
  );
};

export default DictionaryButton;
